import heroImageMobilePng from '@listening/assets/astro/images/Hero-Image---Mobile.png';
import leftLinesPng from '@listening/assets/astro/images/Left-Lines.png';
import rightLinesPng from '@listening/assets/astro/images/Right-Lines.png';
import { createFileRoute } from '@tanstack/react-router';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/survey')({
  head: () => ({
    meta: [
      ...seo({
        title: 'Get Paid by Taking a Survey on Listening.',
        description:
          'Help us enhance the Listening app and get paid! Applying takes just 1 minute—join us today to shape the future of audio learning',
      }),
    ],
  }),
  component: () => (
    <>
      <div className='hidden overflow-hidden sm:block sm:overflow-visible' />
      <div className='mx-0 mt-[25px] mb-0 flex flex-row items-center justify-center overflow-hidden px-[25px] sm:mb-10 sm:overflow-visible sm:px-10 md:mb-0'>
        <img
          alt='Lines'
          className='mx-0 hidden max-w-full sm:mr-10 sm:block'
          loading='lazy'
          src={leftLinesPng}
          width='190'
        />
        <h1 className='mt-[10px] max-w-[400px] flex-[0_auto] text-center text-[25px] leading-[35px] font-[700] sm:mt-0 sm:max-w-[775px] sm:flex-[0_1_auto] sm:text-[50px] sm:leading-[62px] sm:font-[500]'>
          <span className='leading-[70px] font-[600] no-underline'>
            Students: Get paid $30 to chat with us for 30 min
          </span>
        </h1>
        <img
          alt='Lines'
          className='mx-0 hidden sm:ml-10 sm:block'
          loading='lazy'
          src={rightLinesPng}
          width='190'
        />
      </div>
      <div className='mx-auto flex max-w-none justify-center overflow-hidden sm:hidden sm:max-w-[728px] sm:overflow-visible lg:max-w-[940px]'>
        <img
          alt='Hero Mobile'
          className='static mt-5 block max-w-[90%] sm:mt-0 sm:max-w-[auto]'
          id='mobile-hero-image'
          loading='eager'
          src={heroImageMobilePng}
        />
      </div>
      <div className='mx-auto max-w-[88%] overflow-hidden px-0 sm:max-w-[728px] sm:overflow-visible lg:max-w-[1296px] lg:px-[75px]'>
        <div className='mt-[22px] flex justify-center text-center'>
          <h4 className='mt-[25px] max-w-full text-center text-[18px] leading-[30px] font-[300] text-neutral-735 sm:mt-[19px] sm:max-w-[450px] lg:max-w-[500px] lg:text-[25px] lg:leading-[35px] lg:font-[300]'>
            Help us improve our educational apps, while getting paid 🎉
          </h4>
        </div>
      </div>
      <div className='mx-auto max-w-[88%] overflow-hidden px-0 sm:max-w-[728px] sm:overflow-visible lg:max-w-[1296px] lg:px-[75px]'>
        <div className='flex flex-col items-center justify-center text-center'>
          <h4 className='msm:mt-[19px] mt-[25px] max-w-full text-center text-[18px] leading-[30px] font-[300] text-neutral-735 sm:max-w-[450px] lg:max-w-[500px] lg:text-[25px] lg:leading-[35px] lg:font-[300]'>
            Payment sent via Venmo or PayPal, right after the call.
            <br />
            <br />
            Apply here, it takes 1 mins to apply:
          </h4>
        </div>
      </div>
      <div className='mx-auto max-w-[95%] overflow-hidden sm:max-w-[728px] sm:overflow-visible lg:max-w-[1080px] lg:pr-[20px]'>
        <div className='mt-[70px] flex flex-col items-center justify-center overflow-hidden text-[16px] sm:overflow-visible'>
          <a
            className='mt-px block w-[90%] cursor-pointer rounded-[5px] border-0 bg-azure-245 p-[15px] py-[9px] text-center text-[16px] font-[500] text-white no-underline sm:w-[70%] sm:text-[21px]'
            href='https://forms.gle/Twh6HTeSAiaHgoc16'
            id='purchase-btn-top'
          >
            Fill out 1 minute application
          </a>
        </div>
      </div>
      <Footer />
    </>
  ),
});
